import apiClient from './client';

// ─── Typen ──────────────────────────────────────────────────────────────────

export interface Relationship {
  id: string;
  person1Id: string;
  person2Id: string;
  type: 'married' | 'partnership' | 'divorced' | 'separated';
  startDate: string | null;
  endDate: string | null;
  startPlace: string | null;
  notes: string | null;
  createdAt: string;
  person1: { id: string; firstName: string; lastName: string | null };
  person2: { id: string; firstName: string; lastName: string | null };
}

export interface CreateRelationshipDto {
  person1_id: string;
  person2_id: string;
  type: 'married' | 'partnership' | 'divorced' | 'separated';
  start_date_text?: string;
  end_date_text?: string;
  start_place?: string;
  notes?: string;
}

// `null` leert ein Feld beim PATCH; `undefined` lässt es unverändert.
export interface UpdateRelationshipDto {
  type?: 'married' | 'partnership' | 'divorced' | 'separated';
  start_date_text?: string | null;
  end_date_text?: string | null;
  start_place?: string | null;
  notes?: string | null;
}

// ─── API-Funktionen ─────────────────────────────────────────────────────────

/** Beziehungen auflisten (optional nach Person filtern) */
export async function getRelationships(personId?: string): Promise<Relationship[]> {
  const params = personId ? { person_id: personId } : {};
  const { data } = await apiClient.get<{ data: Relationship[] }>('/relationships', { params });
  return data.data;
}

/** Neue Beziehung erstellen */
export async function createRelationship(dto: CreateRelationshipDto): Promise<Relationship> {
  const { data } = await apiClient.post<Relationship>('/relationships', dto);
  return data;
}

/** Beziehung aktualisieren */
export async function updateRelationship(id: string, dto: UpdateRelationshipDto): Promise<Relationship> {
  const { data } = await apiClient.patch<Relationship>(`/relationships/${id}`, dto);
  return data;
}

/** Beziehung löschen */
export async function deleteRelationship(id: string): Promise<void> {
  await apiClient.delete(`/relationships/${id}`);
}
